import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import SupportTeamTabSettings from './SupportTeam';
import Development from './DevelopmentTeam';

class AuditTabSettings extends Component {
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports/audit";
            var path1 = window.origin + "/platform/projectmgmt/reports/audit/";
            if (currentPath === path || currentPath === path1) {
                $("#audit-dev-tab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/reports/audit/support-team')) {
                $("#audit-support-tab").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-used-report-settings-tab")).addClass('active')
            }
            $("#audit-dev-tab,#audit-support-tab")
                .on("click", function () {
                    $("#audit-dev-tab,#audit-support-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-report-settings-tab", $(this)[0].id);
                    $(this).addClass('active')
                })

            $("#audit-support-tab").on("click", function () {
                $("#supervisory-sessions-tab, #escalation-sessions-tab")
                    .removeClass('active');
                $("#supervisory-sessions-tab").addClass('active');
            })
        })();
    }
    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link to="/projectmgmt/reports/audit" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="audit-dev-tab">
                                        Development Team
                                    </li></Link>
                                <Link to="/projectmgmt/reports/audit/support-team" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="audit-support-tab">
                                        Support Team
                                    </li></Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/audit/support-team" component={SupportTeamTabSettings}></Route>
                    <Route path="/projectmgmt/reports/audit" component={Development}></Route>
                </Switch>
            </div>

        );
    }
}
export default AuditTabSettings;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/audit/AuditTabSettings.js